declare const __FEA_POC_VERSION__: string;

const basePath = new URL('./', import.meta.url).href;

const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = `${basePath}loader.css?v=${__FEA_POC_VERSION__}`;
document.head.appendChild(link);

const script = document.createElement('script');
script.type = 'module';
script.src = `${basePath}loader.js?v=${__FEA_POC_VERSION__}`;
document.head.appendChild(script);
